// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottompage[data-v-63715647] {\n  position: fixed;\n  right: 30px;\n  bottom: 20px;\n  z-index: 10;\n  width: 40px;\n  height: 40px;\n  cursor: pointer;\n  padding-bottom: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
